import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import {
  personal,
} from "@/api/personal";
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: () => import('@/pages/homepage/homepage'),
    },
    {
      path: '/activity',
      name: 'activity',
      component: () => import('@/pages/shop/activity'),
    },
    {
      path: '/halfprice',
      name: 'halfprice',
      component: () => import('@/pages/shop/halfprice'),
    },
    {
      path: '/shop',
      name: 'shop',
      component: () => import('@/pages/shop/shop'),
    },
    {
      path: '/exhibition',
      name: 'exhibition',
      component: () => import('@/pages/exhibition/exhibition'),
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('@/pages/news/news'),
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/pages/contact/contact'),
      beforeEnter: (to, from, next) => {
        sessionStorage.setItem('pathname', to.name)
        personal().then(res => {
          if (res.code == 200) {
            next()
            // localStorage.removeItem("accessToken");
            // localStorage.removeItem("account");
            // store.commit("changeRegi", false);
          } else if (res.code == 4001) {
            store.commit("changeShowLogin", true);
          }
        }).catch(err => {
        })
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/register/register'),
    },
    {
      path: '/recovery',
      name: 'recovery',
      component: () => import('@/pages/recovery/recovery'),
    },
    {
      path: '/announcement',
      name: 'announcement',
      component: () => import('@/pages/announcement/announcement'),
    },
    {
      path: '/favor',
      name: 'favor',
      component: () => import('@/pages/favor/favor'),
      beforeEnter: (to, from, next) => {
        sessionStorage.setItem('pathname', to.name)
        personal().then(res => {
          if (res.code == 200) {
            next()
            // localStorage.removeItem("accessToken");
            // localStorage.removeItem("account");
            // store.commit("changeRegi", false);
          } else if (res.code == 4001) {
            store.commit("changeShowLogin", true);
          }
        }).catch(err => {
        })
      }
    },
    {
      path: '/changepass',
      name: 'changepass',
      component: () => import('@/pages/changepass/changepass'),
    },
    {
      path: '/personal',
      name: 'personal',
      component: () => import('@/pages/personal/personal'),
    },
    {
      path: '/vip',
      name: 'vip',
      component: () => import('@/pages/vip/vip'),
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('@/pages/orders/orders'),
      beforeEnter: (to, from, next) => {
        sessionStorage.setItem('pathname', to.name)
        personal().then(res => {
          if (res.code == 200) {
            next()
            // localStorage.removeItem("accessToken");
            // localStorage.removeItem("account");
            // store.commit("changeRegi", false);
          } else if (res.code == 4001) {
            store.commit("changeShowLogin", true);
          }
        }).catch(err => {
        })
      }
    },
    {
      path: '/orders/checklogi',
      name: 'checklogi',
      component: () => import('@/pages/orders/checklogi/checklogi'),
    },
    {
      path: '/orders/checkorder',
      name: 'checkorder',
      component: () => import('@/pages/orders/checkorder/checkorder'),
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import('@/pages/cart/cart'),
    },
    {
      path: '/details',
      name: 'details',
      component: () => import('@/pages/details/details'),
    },
    {
      path: '/details/submitorder',
      name: 'submitorder',
      component: () => import('@/pages/details/submitorder/submitorder'),
      beforeEnter: (to, from, next) => {
        sessionStorage.setItem('pathname', to.name)
        personal().then(res => {
          if (res.code == 200) {
            next()
            // localStorage.removeItem("accessToken");
            // localStorage.removeItem("account");
            // store.commit("changeRegi", false);
          } else if (res.code == 4001) {
            store.commit("changeShowLogin", true);
          }
        }).catch(err => {
        })
      }
    },
    {
      path: '/pay/pay',
      name: 'pay',
      component: () => import('@/pages/pay/pay'),
    },
    {
      path: '/pay/alipay',
      name: 'alipay',
      component: () => import('@/pages/pay/alipay/alipay'),
    },
    {
      path: '/detailNews',
      name: 'detailNews',
      component: () => import('@/pages/news/detailNews/detailNews'),
    },
    {
      path: '/Todetails',
      name: 'Todetails',
      component: () => import('@/pages/details/Todetails'),
    },
    {
      path: '/comment',
      name: 'comment',
      component: () => import('@/pages/comment/comment'),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js